import React from 'react';

import { format } from 'date-fns';

export const DateTime = React.memo<{
  dateUTC: string;
}>(({ dateUTC: date }) => {
  const dateObj = new Date(date);
  const datePart = format(dateObj, 'dd-MM-yyyy');
  const timePart = format(dateObj, 'hh:mm a');

  return (
    <div>
      <div>{datePart}</div>
      <div className="text-sm text-gray-500">{timePart}</div>
    </div>
  );
});
DateTime.displayName = 'DateTime';
